const Notify = {};

Notify.install = function (Vue, options) {

    var successIconCls = "fa-check";
    var infoIconCls = "fa-info";
    var warnIconCls = "fa-exclamation";
    var errorIconCls = "fa-times";
    var notifications = undefined;

    Vue.notifySuccess = function (params) {
        displayNewNotification(params, "success", successIconCls);
    };

    Vue.notifyInfo = function (params) {
        displayNewNotification(params, "info", infoIconCls);
    };

    Vue.notifyWarn = function (params) {
        displayNewNotification(params, "warn", warnIconCls);
    };

    Vue.notifyError = function (params) {
        displayNewNotification(params, "error", errorIconCls);
    };

    function getNotifications() {
        if (!notifications) {
            notifications = document.getElementById("notifications");
        }

        return notifications;
    }

    function displayNewNotification(params, alertCls, iconCls) {
        var newN = createNewNotification(params, alertCls, iconCls);
        var nParent = getNotifications();
        nParent.appendChild(newN);
        setTimeout(function(){nParent.removeChild(newN);}, 10000);
        arrangeNotifications();
    }

    function createNewNotification(params, alertCls, iconCls) {
        var newN = document.createElement("div");
        newN.classList.add("notification");
        newN.classList.add(alertCls);

        var title = "";
        var message = "";
        if (params.hasOwnProperty("title")) {
            title = params.title;
        }
        if (params.hasOwnProperty("message")) {
            message = params.message;
        }

        newN.appendChild(createIcon(iconCls));
        newN.appendChild(createMessage(title, message));

        var close = document.createElement("i");
        close.classList.add("fa");
        close.classList.add("fa-times");
        close.classList.add("close");
        close.onclick = function() {
            getNotifications().removeChild(this.parentNode);
            arrangeNotifications();
        };

        newN.appendChild(close);


        var msgC = document.createElement("div");
        msgC.classList.add("content");
        msgC.innerHTML = message;

        newN.appendChild(msgC);

        return newN;
    }

    function createMessage(title, message) {
        var msgT = document.createElement("div");
        msgT.classList.add("title");
        msgT.innerHTML = title;

        var msg = document.createElement("div");
        msg.classList.add("message");
        msg.appendChild(msgT);

        return msg;
    }

    function createIcon(cls) {
        var ic = document.createElement("i");
        ic.classList.add("fa");
        ic.classList.add("fa-lg");
        ic.classList.add("w3-animate-zoom");
        ic.classList.add(cls);

        var dic = document.createElement("div");
        dic.classList.add("icon");
        dic.appendChild(ic);

        return dic;
    }

    function arrangeNotifications() {
        var notifications = document.getElementsByClassName("notification");
        var bottom = getTop();
        for (var i = notifications.length - 1; i >= 0; i--) {
            var notification = notifications[i];
            notification.style.bottom = bottom + "px";
            bottom += notification.offsetHeight + 5;
            notification.style.visibility = "visible";
        }
    }

    function getTop() {
        var fc = document.getElementById("flow-content");
        if (fc) {
            return fc.offsetTop;
        } else {
            return 40;
        }
    }
    
    function closeOnClick() {
        console.log("closing");
        getNotifications().removeChild(this);
    }

};

export default Notify;